const translations = {
    'forest.ageBucket': '- wiek %d: %d',
    'forest.noTrees': 'Brak drzew.',
    'forest.section': 'Podgląd lasu',
    'forest.treesByAge': 'Drzewa wg wieku',
    'forest.treesTotal': 'Drzewa razem: %d',
};

export default translations;
